// NOTE all the paths MUST be relative. DO NOT START THEM WITH '/'

const BASE_ROUTE = 'etp-root'

export const ROUTE_NAMES = {
  LIST: 'etp-list',
  DETAILS: 'etp-details'
}

const ROUTES = {
  [BASE_ROUTE]: {
    name: BASE_ROUTE,
    path: 'etp'
  },
  [ROUTE_NAMES.LIST]: {
    name: ROUTE_NAMES.LIST,
    path: 'list'
  },
  [ROUTE_NAMES.DETAILS]: {
    name: ROUTE_NAMES.DETAILS,
    path: ':id'
  }
}

export default [
  {
    name: ROUTES[BASE_ROUTE].name,
    path: ROUTES[BASE_ROUTE].path,
    component: {
      template: '<router-view></router-view>',
      name: 'EtpModule'
    },
    children: [
      {
        name: ROUTES[ROUTE_NAMES.LIST].name,
        path: ROUTES[ROUTE_NAMES.LIST].path,
        component: (resolve) => require(['./views/list'], resolve)
      },
      {
        name: ROUTES[ROUTE_NAMES.DETAILS].name,
        path: ROUTES[ROUTE_NAMES.DETAILS].path,
        component: (resolve) => require(['./views/details'], resolve),
        props: true
      }
    ]
  }
]
